import React from "react";
import { useTranslation } from "react-i18next";
import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

export function OfflineOverlay() {
	const isOnline = useOnlineStatus();
	const { t } = useTranslation();

	if (isOnline) {
		return null;
	}

	return (
		<div
			role="alert"
			aria-live="assertive"
			aria-label={t("common.offline.title")}
			className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm"
		>
			<div className="mx-4 flex max-w-md flex-col items-center gap-4 rounded-lg border bg-background p-8 text-center shadow-lg">
				<WifiOff className="h-16 w-16 shrink-0 text-red-400" aria-hidden />
				<div className="space-y-4">
					<h2 className="text-xl font-semibold text-foreground">{t("common.offline.title")}</h2>
					<p className="text-sm text-muted-foreground">{t("common.offline.description")}</p>
				</div>
			</div>
		</div>
	);
}
